export default [
    {
        title: 'Assets',
        route: 'home',
        icon: 'HomeIcon',
    },
    
    
    {
        title: 'Map',
        route: 'map',
        icon: 'MapIcon',
    },
    {
        title: 'Users',
        route: 'list-user',
        icon: 'UserIcon',
    },
    {
        title: 'Customers',
        route: 'list-customer',
        icon: 'UsersIcon',
    },
    {
        title: 'Dealers',
        route: 'list-dealer',
        icon: 'UserCheckIcon',
    },
    {
        title: 'Devices',
        route: 'list-device',
        icon: 'HardDriveIcon',
    },
    {
        title: 'Drivers/Operators',
        icon: 'TruckIcon',
        children: [
            {
                title: 'Search',
                route: 'list-driver',
            },
            {
                title: 'Identification',
                route: 'list-driver-attribute',
            },
        ]
    },
    {
        title: 'Admin',
        icon: 'CoffeeIcon',
        children: [
            {
                title: 'Manufacturer',
                route: 'list-manufacturer'
            },
            {
                title: 'Models',
                route: 'list-model'
            },
            {
                title: 'Installations',
                route: 'devices-installations'
            },
            {
                title: 'All Devices',
                route: 'list-all-device',
            },
            {
                title: 'Customer DNS',
                route: 'list-customer-dns',
            },
            {
                title: 'Limite',
                route: 'list-model-limits',
            },
            {
                title: 'Inbound',
                route: 'inbound-integrations-list',
               
            },
            {
                title: 'DTC',
                route: 'dtc-list',
            },
        ]
    },

    {
        title: 'Reports',
        icon: 'FileTextIcon',
        children: [
            {
                title: 'Measurement',
                route: 'report-usage'
            },
            {
                title: 'Physical Availability',
                route: 'maintenance-time'
            },
            {
                title: 'Comparative',
                route: 'fleet-dashboard',
            },
            {
                title: 'Productivity',
                route: 'operational-time',
            },
            
        ]
    },
    {
        title: 'Management',
        icon: 'SettingsIcon',
        children: [
            {
                title: 'Fuelling',
                route: 'list-fuelling',
            },
            {
                title: 'Alarms',
                route: 'customer-alarms',
            },
            {
                title: 'Group',
                route: 'list-group',
            },
            {
                title: 'Fence',
                route: 'fence-management',
            },

        ],
    },
    {
        title: 'Maintenance',
        icon: 'CalendarIcon',
        children: [
            {
                title: 'Plan/Preventive',
                route: 'list-maintenance-plan',
            },
            {
                title: 'Failures',
                route: 'customer-failure',
            },
            {
                title: 'Executed',
                route: 'list-maintenance',
            },
        ],
    },
    {
        title: 'Safe Spot',
        route: 'safespot',
        icon: 'HardDriveIcon',
    },
]